import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@ci-ville/ui';
import { MapPinOff } from 'lucide-react';
export function NotFoundPage() {
    return (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-background", children: _jsx(EmptyState, { icon: _jsx(MapPinOff, {}), title: "Page introuvable", description: "Cette page n'existe pas ou a \u00E9t\u00E9 d\u00E9plac\u00E9e.", action: _jsx(Button, { asChild: true, variant: "brand", children: _jsx(Link, { to: "/dashboard", children: "Retour au tableau de bord" }) }) }) }));
}
//# sourceMappingURL=NotFoundPage.js.map